import React from "react";

import { useTranslation } from "react-i18next";

import { Container, Image, Text } from "./styles";

const EmptySectionImage = require("Assets/img/heavy-box/amico.png");

interface EmptySectionProp {
  title?: string;
}

export default function EmptySection({ title }: EmptySectionProp) {
  const { t: translate } = useTranslation();

  return (
    <Container>
      <Image src={EmptySectionImage} alt="heavy-boxes" />
      <Text>{title ?? translate("nothingToShowHereYet")}</Text>
    </Container>
  );
}
